import React, { useState } from "react";
import { Box, Tabs, Tab, Divider } from "@mui/material";

const rootStyle = {
  width: "100%",
  position: 'relative',
  zIndex: '1'
};

const tabStyle = (active) => ({
  fontSize: {
    xs: 10,
    md: 12,
    lg: 16,
  },
  fontWeight: 500,
  color: active ? "#0066CC" : "rgba(0,0,0,0.7)",
  textTransform: "none",
});

const tabLabelWrapperStyle = {
  display: "flex",
  alignItems: "center",
  gap: 4,
};

const dividerStyle = {
  border: "1px solid #D9E1E7",
};

const tabPanelWrapperStyle = {
  padding: { sm: "10px", md: "12px", lg: "16px" },
};

const promptsContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
};

const promptItemStyle = {
  marginBottom: "8px",
  padding: { sm: "12px", md: "16px", lg: "24px" },
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: {
    xs: 8,
    md: 12,
    lg: 14,
  },
  lineHeight: "160%",
  fontWeight: 400,
  color: "#667F93",
  transition: "0.2s",
  textAlign: "left",
  backgroundColor: "#FFFFFF !important",
  height: { sm: "80px", md: "96px", lg: "140px" },
};

export const Prompts = ({ tabs, onPromptClick, view }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const prompts = tabs?.[tabIndex]?.prompts || [];
  const emptyMessage =
    tabIndex === 0
      ? "No prompts available"
      : tabIndex === 1
        ? "No prompts available"
        : "No data available";
  return (
    <Box sx={rootStyle}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        textColor="inherit"
        TabIndicatorProps={{
          style: { backgroundColor: "#0066CC", height: 3 },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            sx={tabStyle(tabIndex === index)}
            label={
              <Box sx={tabLabelWrapperStyle}>
                {tab.iconStart}
                <span>{tab.label}</span>
                {tab.iconEnd}
              </Box>
            }
          />
        ))}
      </Tabs>

      <Divider sx={dividerStyle} />

      <Box sx={tabPanelWrapperStyle}>
        <Box sx={promptsContainerStyle}>
          {prompts.length > 0 ? (
            prompts.map((prompt, idx) => {
              const isSelected = selectedPrompt === prompt;
              return (
                <Box
                  key={idx}
                  sx={{
                    ...promptItemStyle,
                    flex: {
                      md: view === "dashboards" ? "1 1 120px" : "1 1 140px",
                      lg: view === "dashboards" ? "1 1 150px" : "1 1 250px",
                    },
                    border: "2px solid #F5F8FB",
                    "&:hover": {
                      backgroundColor: "#F5F8FB",
                    },
                    "&:hover .resize-corner": {
                      opacity: 1,
                    },
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedPrompt(prompt);
                    onPromptClick(prompt);
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      height: "100%",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      WebkitLineClamp: 3,
                      "@media (min-width:900px)": {
                        WebkitLineClamp: 3,
                      },
                      "@media (min-width:1200px)": {
                        WebkitLineClamp: 4,
                      },
                    }}
                  >
                    {prompt}
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        width: 20,
                        height: 20,
                        cursor: "nwse-resize",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: 0,
                        transition: "opacity 0.2s",
                        color: "#0066CC",
                      }}
                      className="resize-corner"
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M1 13L13 1M13 1H5M13 1V9"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Box>
                  </Box>
                </Box>
              );
            })
          ) : (
            <Box
              sx={{
                p: 2,
                color: "#888",
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {emptyMessage}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
